import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseUnpaidConsolidatedPaymentReminderTemplates = [
  {
    id: '-229001',
    language: Language.EN,
    subject: 'Outstanding amounts',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_UNPAID_CONSOLIDATED_PAYMENT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>An amount of {{totalAmount}} € remains unpaid.</p>
          <p>More details here: {{pdfLink}}.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-229002',
    language: Language.FR,
    subject: 'Créances ouvertes',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_UNPAID_CONSOLIDATED_PAYMENT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Le montant de {{totalAmount}} € demeure impayé.</p>
          <p>Plus de détails ici : {{pdfLink}}.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-229003',
    language: Language.NL,
    subject: 'Openstaand bedrag',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_UNPAID_CONSOLIDATED_PAYMENT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Beste huurder,</p>
        <p>Een bedrag van {{totalAmount}} € blijft onbetaald.</p>
        <p>Meer details hier: {{pdfLink}}.</p>
        <p>Groeten.</p>
      `,
  },
  {
    id: '-229004',
    language: Language.DE,
    subject: 'Ausstehende Beträge',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_UNPAID_CONSOLIDATED_PAYMENT_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r Mieter/in,</p>
        <p>Ein Betrag von {{totalAmount}} € ist noch unbezahlt.</p>
        <p>Weitere Details hier: {{pdfLink}}.</p>
        <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
